import styled, { css, keyframes } from 'styled-components';
import { colorCSS, radius, shadow } from '../../styles';
const placeholderGlow = keyframes `
  50% { opacity: 0.37; }
`;
const placeholderCSS = css `
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-name: ${placeholderGlow};
  background-color: currentcolor;
  opacity: 0.5;
`;
export const PlaceholderImage = styled.div `
  ${placeholderCSS}
  height: 0;
  padding-bottom: 50%;
`;
export const PlaceholderText = styled.span `
  ${placeholderCSS}
  display: inline-block;
`;
const blogArticleCss = css `
  background-color: ${colorCSS('N0')};
  border-radius: ${radius['button']};
  color: ${colorCSS('N800')} !important;
  display: block;
  margin: 2rem 0 1.5rem;
  padding-bottom: 1rem;
  text-align: left;
  text-decoration: none;
  width: 100%;
  img,
  ${PlaceholderImage} {
    border-radius: ${radius['button']} ${radius['button']} 0 0;
  }
`;
export const Link = styled.a `
  ${blogArticleCss}
  transition: box-shadow 0.3s;
  &:hover {
    box-shadow: ${shadow.normal};
  }
`;
export const PlaceholderFrame = styled.div `
  ${blogArticleCss}
  &:hover {
    cursor: wait;
  }
`;
export const Eyebrow = styled.p `
  color: ${colorCSS('N400')};
  font-size: 0.75rem;
  margin: 1rem 1rem 0;
  text-transform: uppercase;
  ${PlaceholderText} {
    min-height: 1rem;
    width: 80%;
  }
`;
export const Title = styled.p `
  font-size: 1rem;
  margin: 0.5rem 1rem 0;
  ${PlaceholderText} {
    height: 3rem;
    width: 90%;
  }
`;
//neutralizes 1rem padding in child UiNavBanner
export const FallbackBanner = styled.div `
  margin: -1rem;
`;
//# sourceMappingURL=UiNavBlogArticle.styles.js.map